/**
 * Tier Package & Zone Type Definitions
 * Feature: 007-tv-landing-tiers
 * Created: 2026-07-16
 *
 * Shared types for TV Landing Page tier packages, JAKIM zones, mosques, and displays
 */
/**
 * Service Error Types
 */
export var ServiceErrorCode;
(function (ServiceErrorCode) {
    ServiceErrorCode["ZONE_NOT_FOUND"] = "ZONE_NOT_FOUND";
    ServiceErrorCode["TIER_NOT_FOUND"] = "TIER_NOT_FOUND";
    ServiceErrorCode["NO_MOSQUES_IN_ZONE"] = "NO_MOSQUES_IN_ZONE";
    ServiceErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    ServiceErrorCode["PRAYER_TIMES_UNAVAILABLE"] = "PRAYER_TIMES_UNAVAILABLE";
    ServiceErrorCode["INVALID_TIER_UPGRADE"] = "INVALID_TIER_UPGRADE";
    ServiceErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    ServiceErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ServiceErrorCode["UNKNOWN"] = "UNKNOWN";
})(ServiceErrorCode || (ServiceErrorCode = {}));
export class ServiceError extends Error {
    constructor(code, message, statusCode = 500, context) {
        super(message);
        this.code = code;
        this.statusCode = statusCode;
        this.context = context;
        this.name = "ServiceError";
    }
}
/**
 * Default tier feature set
 */
export const DEFAULT_TIER_FEATURES = {
    asas: [
        {
            id: "prayer_times",
            name_ms: "Waktu Solat JAKIM",
            name_en: "JAKIM Prayer Times",
            supported_tiers: ["asas", "maju", "gemilang", "istimewa"],
        },
        {
            id: "fixed_background",
            name_ms: "Latar Belakang Tetap",
            name_en: "Fixed Background",
            supported_tiers: ["asas", "maju"],
        },
        {
            id: "no_login",
            name_ms: "Tanpa Pendaftaran",
            name_en: "No Sign-up",
            supported_tiers: ["asas"],
        },
    ],
    maju: [
        {
            id: "prayer_times",
            name_ms: "Waktu Solat JAKIM",
            name_en: "JAKIM Prayer Times",
            supported_tiers: ["asas", "maju", "gemilang", "istimewa"],
        },
        {
            id: "managed_content",
            name_ms: "Kandungan Terurus (WhatsApp)",
            name_en: "Managed Content (WhatsApp)",
            supported_tiers: ["maju", "gemilang", "istimewa"],
        },
        {
            id: "single_screen",
            name_ms: "1 Skrin",
            name_en: "1 Screen",
            supported_tiers: ["asas", "maju"],
        },
    ],
    gemilang: [
        {
            id: "prayer_times",
            name_ms: "Waktu Solat JAKIM",
            name_en: "JAKIM Prayer Times",
            supported_tiers: ["asas", "maju", "gemilang", "istimewa"],
        },
        {
            id: "admin_dashboard",
            name_ms: "Papan Pemuka Pentadbir",
            name_en: "Admin Dashboard",
            supported_tiers: ["gemilang", "istimewa"],
        },
        {
            id: "custom_content",
            name_ms: "Kandungan Tersuai",
            name_en: "Custom Content",
            supported_tiers: ["gemilang", "istimewa"],
        },
        {
            id: "unlimited_screens",
            name_ms: "Skrin Tanpa Had",
            name_en: "Unlimited Screens",
            supported_tiers: ["gemilang", "istimewa"],
        },
    ],
    istimewa: [
        {
            id: "prayer_times",
            name_ms: "Waktu Solat JAKIM",
            name_en: "JAKIM Prayer Times",
            supported_tiers: ["asas", "maju", "gemilang", "istimewa"],
        },
        {
            id: "admin_dashboard",
            name_ms: "Papan Pemuka Pentadbir",
            name_en: "Admin Dashboard",
            supported_tiers: ["gemilang", "istimewa"],
        },
        {
            id: "api_integration",
            name_ms: "Penyepaduan API",
            name_en: "API Integration",
            supported_tiers: ["istimewa"],
        },
        {
            id: "multi_branch",
            name_ms: "Berbilang Cawangan",
            name_en: "Multi-branch",
            supported_tiers: ["istimewa"],
        },
        {
            id: "dedicated_support",
            name_ms: "Sokongan Khusus",
            name_en: "Dedicated Support",
            supported_tiers: ["istimewa"],
        },
    ],
};
